<!--
   Search panel above a table: search box, Search button (button mode only) and records-per-page.
   Use:
     <SearchBox
        v-model:search-query="tableData.searchQuery"
        v-model:records-per-page="tableData.recordsPerPage"
        :placeholder="tableData.searchPlaceHolderText"
        @search-input="onSearchInput"
        @search-click="onSearchButtonClick"
        @per-page-change="onRecordsPerPageChange"
     />
   - The box keeps id="search" (changePlaceholder puts the cursor there).
   - v-show / v-if on <SearchBox> work as on a normal <div>.
-->
<template>
   <div class="d-flex justify-content-between align-items-center p-1 flex-nowrap gap-2 bg-table-search-panel">
      <!-- Left: Search -->
      <div class="d-flex align-items-center gap-2">
         <div class="input-group">
            <span class="input-group-text d-md-flex"><i class="fa fa-search"></i></span>
            <input
               id="search"
               v-model="query"
               @input="$emit('search-input')"
               @keydown.enter.prevent="$emit('search-click')"
               :placeholder="placeholder"
               type="search"
               class="form-control form-control-sm"
            />
            <button
               v-if="$searchWithButtonClick"
               @click="$emit('search-click')"
               type="button"
               class="btn btn-primary btn-sm"
               title="Search (Enter)"
            >
               <i class="fa fa-search"></i><span class="d-none d-sm-inline"> {{ $loaderMessages.searchBtnText }}</span>
            </button>
         </div>
      </div>
      <!-- Right: Entries select -->
      <div class="d-flex align-items-center gap-1">
         <select
            id="recordsPerPage"
            v-model="perPage"
            @change="$emit('per-page-change')"
            class="form-select form-select-sm entries-select"
         >
            <option v-for="n in perPageOptions" :key="n" :value="String(n)">{{ n }}</option>
         </select>
      </div>
   </div>
</template>

<script>
export default {
   name: "SearchBox",
   props: {
      // tableData.searchQuery (use v-model:search-query)
      searchQuery: { type: String, default: "" },
      // tableData.recordsPerPage (use v-model:records-per-page)
      recordsPerPage: { type: [String, Number], default: 10 },
      // tableData.searchPlaceHolderText
      placeholder: { type: String, default: "" },
      // Choices in the records-per-page list
      perPageOptions: { type: Array, default: () => [5, 10, 25, 50] },
   },
   emits: ["update:searchQuery", "update:recordsPerPage", "search-input", "search-click", "per-page-change"],
   computed: {
      // The page's value is updated first, then search-input / per-page-change is sent
      query: {
         get() { return this.searchQuery; },
         set(value) { this.$emit("update:searchQuery", value); },
      },
      perPage: {
         get() { return String(this.recordsPerPage); },
         set(value) { this.$emit("update:recordsPerPage", value); },
      },
   },
};
</script>
